import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../config.service';

export interface IncidentSeverityImpact {
  id?: number;
  workItemId: number;
  staffId: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  personalInjuryLevel: number; // 0=No, 1=Minor, 2=Moderate, 3=Major
  financialImpactLevel: number; // 0=No, 1=Minor, 2=Moderate, 3=Significant
  financialAmount?: number;
  additionalNotes?: string;
}

export interface IncidentSeverityImpactFormData {
  personalInjuryLevel: number;
  financialImpactLevel: number;
  financialAmount?: number;
  additionalNotes?: string;
}

export const PERSONAL_INJURY_OPTIONS = [
  { value: 0, label: 'No' },
  { value: 1, label: 'Minor (Cut/bruise/etc that was able to be taken care of on site.)' },
  { value: 2, label: 'Moderate (Injury requiring off-site medical attention, e.g., a sprain, broken finger, or stitches.)' },
  { value: 3, label: 'Major (Severe injury requiring extensive medical treatment or hospitalization, e.g., a broken limb, concussion, or significant burns.)' }
];

export const FINANCIAL_IMPACT_OPTIONS = [
  { value: 0, label: 'No (No direct financial impact or costs were incurred.)' },
  { value: 1, label: 'Minor (Costs under $500)' },
  { value: 2, label: 'Moderate ($500-$1500)' },
  { value: 3, label: 'Significant (Over $1500)' }
];

@Injectable({
  providedIn: 'root'
})
export class IncidentSeverityImpactService {

  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) { }

  getSeverityImpact(workItemId: number): Observable<IncidentSeverityImpact | null> {
    return this.http.get<IncidentSeverityImpact | null>(`${this.config.dataApiUrl}/incidents/${workItemId}/severity-impact`);
  }

  createSeverityImpact(workItemId: number, data: IncidentSeverityImpactFormData): Observable<IncidentSeverityImpact> {
    return this.http.post<IncidentSeverityImpact>(`${this.config.dataApiUrl}/incidents/${workItemId}/severity-impact`, data);
  }

  updateSeverityImpact(workItemId: number, data: IncidentSeverityImpactFormData): Observable<IncidentSeverityImpact> {
    return this.http.put<IncidentSeverityImpact>(`${this.config.dataApiUrl}/incidents/${workItemId}/severity-impact`, data);
  }
} 